import { removeSubscription } from "../../Core/remove-subscription.js";
import { SUBSCRIPTION_ID_DATA_ATTRIBUTE as f } from "../../common/constants.js";
export function destroyBannerHtml(o) {
  var n = o.getAttribute(f);
  null != n && removeSubscription(n), o && o.parentNode && o.parentNode.removeChild(o);
}